import {remapAttachmentSourceNodeIds} from '../config/teamEmail';

const htmlEntities: Record<string, string> = {
    '&amp;': '&', '&lt;': '<', '&gt;': '>', '&quot;': '"', '&#34;': '"', '&#39;': "'", '&apos;': "'"
};
const decodeHtmlLabel = (label: string): string => label.replace(/&(?:amp|lt|gt|quot|#34|#39|apos);/g, entity => htmlEntities[entity]);
const encodeHtmlLabel = (label: string): string => label.replace(/[&<>"']/g,
    character => ({'&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;'}[character]!));

export const remapCopiedNodeConfig = (
    config: Record<string, any>, ids: ReadonlyMap<string, string>, labels: ReadonlyMap<string, string>
): Record<string, any> => {
    const remap = (value: any): any => {
        if (typeof value === 'string') {
            // Tokens occur as raw text, JSON-escaped design values and HTML-encoded link attributes.
            return value.replace(/\{\{(\\?"|&quot;|&#34;)([^{}\r\n]*?)\1\./g,
                (match, quote: string, label: string) => {
                    const htmlEncoded = quote.startsWith('&');
                    const sourceLabel = !htmlEncoded && labels.has(label) ? label : decodeHtmlLabel(label);
                    const replacement = labels.get(sourceLabel);
                    if (replacement === undefined) return match;
                    const nextLabel = htmlEncoded || sourceLabel !== label ? encodeHtmlLabel(replacement) : replacement;
                    return `{{${quote}${nextLabel}${quote}.`;
                });
        }
        if (Array.isArray(value)) return value.map(remap);
        if (value && typeof value === 'object') return Object.fromEntries(Object.entries(value).map(([key, item]) => [key, remap(item)]));
        return value;
    };
    return remap(remapAttachmentSourceNodeIds(config, ids));
};
